import { Component, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Authentication } from '../../../providers';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'side-menu',
  styleUrls: ['./side_menu.scss'],
  templateUrl: './side_menu.pug',
  encapsulation: ViewEncapsulation.None
})

export class SideMenuComponent implements OnInit {
  public currentUser = JSON.parse(window.localStorage.getItem('currentUser'));

  constructor(private route: ActivatedRoute,
              private router: Router,
              private renderer: Renderer2,
              private toastr: ToastsManager,
              private authService: Authentication) {}

  public ngOnInit() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.closeMenu();
      }
    });
  }

  public logOut() {
    this.authService.logOut();
    this.closeMenu();
  }

  private closeMenu() {
    this.renderer.removeClass(document.body, 'sidemenu-open');
  }
}



// WEBPACK FOOTER //
// ./src/components/+utils/side_menu/side_menu.ts